import GetSiHaDocumentationsRequestModelBase from '../_generated/modelBases/get-si-ha-documentations-request-model-base';

export default class GetSiHaDocumentationsRequestModel extends GetSiHaDocumentationsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
